import { custom, failure, success } from "./utilities";
import { propertyService } from "../../services";
import { globalConstants, propertyConstants } from "../../constants";
import { customToast } from "../../shared/utility";
import { ERROR_TOAST, SUCCESS_TOAST } from "../../constants/toast.constants";

const {
  PROPERTY_ID,
  ALL_PROPERTY_TYPES,
  USER_PROPERTY_TYPES,
  ALL_FRESH_PROPERTY,
  FAVOURITE_PROPERTY,
  INTERESTED_PROPERTY,
  ALL_FAVOURITES_PROPERTY,
  USER_FAVOURITES_PROPERTY,
  ALL_RECOMMENDED_PROPERTY,
  GET_PROPERTY_DETAIL_BY_ID,
  ALL_RECOMMENDED_PROPERTY_BUTTON,
  CREATE_PROPERTY,
  SAVE_PROPERTY_DRAFT,
  GET_PROPERTY_DRAFT,
  ALL_VIEW_TYPES,
  ALL_PROPERTIES,
} = propertyConstants;

//Get all fresh properties responses
const getAllPropertyTypes = () => {
  return (dispatch) => {
    dispatch(custom(ALL_PROPERTY_TYPES, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .getAllPropertyTypes()
      .then(
        (response) => {
          dispatch(success(response.data, ALL_PROPERTY_TYPES));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(custom(ALL_PROPERTY_TYPES, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

//Get all fresh properties responses
const getAllViewTypes = () => {
  return (dispatch) => {
    propertyService.getAllViewTypes().then(
      (response) => {
        dispatch(success(response.data, ALL_VIEW_TYPES));
      },
      (error) => {}
    );
  };
};

const getPropertyTypesByUser = (data) => {
  return (dispatch) => {
    dispatch(custom(USER_PROPERTY_TYPES, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .getPropertyTypesByUser(data)
      .then(
        (response) => {
          dispatch(success(response.data, USER_PROPERTY_TYPES));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(
          custom(USER_PROPERTY_TYPES, globalConstants.SPINNER_DIACTIVATE)
        )
      );
  };
};

/** Client-side preferred property types (used for guest browsing). */
const setPropertyTypesLocally = (types) => {
  return (dispatch) => {
    dispatch(success(types || [], USER_PROPERTY_TYPES));
  };
};

const addPropertyTypeForUser = (data, successFunc) => {
  return (dispatch) => {
    dispatch(custom("", globalConstants.SPINNER_ACTIVATE));
    propertyService
      .addPropertyTypeForUser(data)
      .then(
        (response) => {
          customToast(response.msg, SUCCESS_TOAST);
          successFunc();
        },
        (error) => {}
      )
      .finally(() => dispatch(custom("", globalConstants.SPINNER_DIACTIVATE)));
  };
};

const makePropertyFavourite = (id, successFunc = () => {}) => {
  return (dispatch) => {
    propertyService.makePropertyFavourite(id).then(
      (response) => {
        successFunc();
      },
      (error) => {}
    );
  };
};

const removePropertyFromFavourite = (id, successFunc = () => {}) => {
  return (dispatch) => {
    propertyService.removePropertyFromFavourite(id).then(
      (response) => {
        successFunc();
      },
      (error) => {}
    );
  };
};

//Get all fresh properties responses
const getAllFreshProperty = (data) => {
  return (dispatch) => {
    dispatch(custom(ALL_FRESH_PROPERTY, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .getAllFreshProperty(data)
      .then(
        (response) => {
          dispatch(success(response.data, ALL_FRESH_PROPERTY));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(custom(ALL_FRESH_PROPERTY, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

//Get all recommended properties responses
const getAllRecommendedProperty = (data, concat = true) => {
  let tempData = {
    ...data,
    pageNumber: concat ? 0 : data.pageNumber,
    pageSize: concat ? (data.pageNumber + 1) * 12 : data.pageSize,
  };
  return (dispatch) => {
    dispatch(
      custom(
        tempData.pageNumber === 0
          ? ALL_RECOMMENDED_PROPERTY
          : ALL_RECOMMENDED_PROPERTY_BUTTON,
        globalConstants.SPINNER_ACTIVATE
      )
    );
    propertyService
      .getAllRecommendedProperty(tempData)
      .then(
        (response) => {
          dispatch(
            success(
              response.data,
              tempData.pageNumber === 0
                ? ALL_RECOMMENDED_PROPERTY
                : ALL_RECOMMENDED_PROPERTY_BUTTON
            )
          );
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(
          custom(
            tempData.pageNumber === 0
              ? ALL_RECOMMENDED_PROPERTY
              : ALL_RECOMMENDED_PROPERTY_BUTTON,
            globalConstants.SPINNER_DIACTIVATE
          )
        )
      );
  };
};

//Get all favourites properties responses
const getAllFavouritesProperty = (data) => {
  return (dispatch) => {
    dispatch(custom(ALL_FAVOURITES_PROPERTY, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .getAllFavouritesProperty(data)
      .then(
        (response) => {
          dispatch(success(response.data, ALL_FAVOURITES_PROPERTY));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(
          custom(ALL_FAVOURITES_PROPERTY, globalConstants.SPINNER_DIACTIVATE)
        )
      );
  };
};
//Get all favourites properties responses
const getAllFavouritesPropertyForUser = () => {
  return (dispatch) => {
    dispatch(custom(ALL_FAVOURITES_PROPERTY, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .getAllFavouritesPropertyForUser()
      .then(
        (response) => {
          dispatch(success(response.data, USER_FAVOURITES_PROPERTY));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(
          custom(ALL_FAVOURITES_PROPERTY, globalConstants.SPINNER_DIACTIVATE)
        )
      );
  };
};

//Get all properties with pagination
const getAllProperties = (data) => {
  return (dispatch) => {
    dispatch(custom(ALL_PROPERTIES, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .getAllProperties(data)
      .then(
        (response) => {
          dispatch(success(response.data, ALL_PROPERTIES));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(custom(ALL_PROPERTIES, globalConstants.SPINNER_DIACTIVATE))
      );
  };
};

//Get property detail responses
const getPropertyDetailById = (propertyId) => {
  return (dispatch) => {
    dispatch(
      custom(GET_PROPERTY_DETAIL_BY_ID, globalConstants.SPINNER_ACTIVATE)
    );
    propertyService
      .getPropertyDetailById(propertyId)
      .then(
        (response) => {
          dispatch(success(response.data, GET_PROPERTY_DETAIL_BY_ID));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(
          custom(GET_PROPERTY_DETAIL_BY_ID, globalConstants.SPINNER_DIACTIVATE)
        )
      );
  };
};
//Get property detail responses
const getPropertyDetailsForUser = (propertyId) => {
  return (dispatch) => {
    dispatch(
      custom(GET_PROPERTY_DETAIL_BY_ID, globalConstants.SPINNER_ACTIVATE)
    );
    propertyService
      .getPropertyDetailsForUser(propertyId)
      .then(
        (response) => {
          dispatch(success(response.data, GET_PROPERTY_DETAIL_BY_ID));
        },
        (error) => {}
      )
      .finally(() =>
        dispatch(
          custom(GET_PROPERTY_DETAIL_BY_ID, globalConstants.SPINNER_DIACTIVATE)
        )
      );
  };
};

// Property mark as favourite
const addToFavouriteProperty = (body) => {
  return (dispatch) => {
    propertyService.addToFavouriteProperty(body).then(
      (response) => {
        dispatch(success(response?.data, FAVOURITE_PROPERTY));
      },
      (_error) => {
        dispatch(failure(body, FAVOURITE_PROPERTY));
      }
    );
  };
};

// Property mark as favourite
const removeFromFavouriteProperty = (body) => {
  return (dispatch) => {
    propertyService.removeFromFavouriteProperty(body).then(
      (response) => {
        dispatch(success(response?.data, FAVOURITE_PROPERTY));
      },
      (_error) => {
        dispatch(failure(body, FAVOURITE_PROPERTY));
      }
    );
  };
};

// Property mark as not interested
const addToNotInterestedProperty = (id, successFunc = () => {}) => {
  return (dispatch) => {
    propertyService.addToNotInterestedProperty(id).then(
      (response) => {
        dispatch(success(response?.data, INTERESTED_PROPERTY));
        successFunc(true);
      },
      (_error) => {
        dispatch(failure(id, INTERESTED_PROPERTY));
      }
    );
  };
};

// Property remove from not interested
const removeFromNotInterestedProperty = (body) => {
  return (dispatch) => {
    propertyService.removeFromNotInterestedProperty(body).then(
      (response) => {
        dispatch(success(response?.data, INTERESTED_PROPERTY));
      },
      (_error) => {
        dispatch(failure(body, INTERESTED_PROPERTY));
      }
    );
  };
};

const createProperty =
  (data, successFunc = () => {}) =>
  (dispatch) => {
    dispatch(custom(CREATE_PROPERTY, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .createProperty(data)
      .then(
        (response) => {
          customToast(response.msg, SUCCESS_TOAST);
          successFunc();
        },
        (error) => customToast(error[0], ERROR_TOAST)
      )
      .finally(() =>
        dispatch(custom(CREATE_PROPERTY, globalConstants.SPINNER_DIACTIVATE))
      );
  };

const updateProperty =
  (data, successFunc = () => {}) =>
  (dispatch) => {
    dispatch(custom(CREATE_PROPERTY, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .updateProperty(data)
      .then(
        (response) => {
          customToast(response.msg, SUCCESS_TOAST);
          successFunc();
        },
        (error) => customToast(error[0], ERROR_TOAST)
      )
      .finally(() =>
        dispatch(custom(CREATE_PROPERTY, globalConstants.SPINNER_DIACTIVATE))
      );
  };

const savePropertyDraft =
  (data, successFunc = () => {}) =>
  (dispatch) => {
    dispatch(custom(SAVE_PROPERTY_DRAFT, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .savePropertyDraft(data)
      .then(
        (response) => {
          customToast(response.msg, SUCCESS_TOAST);
          successFunc(response?.data);
        },
        (error) => customToast(error[0], ERROR_TOAST)
      )
      .finally(() =>
        dispatch(custom(SAVE_PROPERTY_DRAFT, globalConstants.SPINNER_DIACTIVATE))
      );
  };

const getPropertyDraft =
  (successFunc = () => {}, emptyFunc = () => {}, showRetrievedToast = false) =>
  (dispatch) => {
    dispatch(custom(GET_PROPERTY_DRAFT, globalConstants.SPINNER_ACTIVATE));
    propertyService
      .getPropertyDraft()
      .then(
        (response) => {
          if (response?.data) {
            if (showRetrievedToast) {
              customToast(response.msg, SUCCESS_TOAST);
            }
            successFunc(response.data);
          } else {
            emptyFunc();
          }
        },
        (error) => customToast(error[0], ERROR_TOAST)
      )
      .finally(() =>
        dispatch(custom(GET_PROPERTY_DRAFT, globalConstants.SPINNER_DIACTIVATE))
      );
  };

const setPropertyId = (propertyId) => {
  return (dispatch) => dispatch(custom(propertyId, PROPERTY_ID));
};

export const propertyActions = {
  getAllPropertyTypes,
  getAllViewTypes,
  getAllFreshProperty,
  getPropertyDetailById,
  getPropertyDetailsForUser,
  getAllFavouritesProperty,
  getAllRecommendedProperty,
  addToFavouriteProperty,
  removeFromFavouriteProperty,
  addToNotInterestedProperty,
  removeFromNotInterestedProperty,
  createProperty,
  updateProperty,
  savePropertyDraft,
  getPropertyDraft,
  getAllProperties,
  getPropertyTypesByUser,
  setPropertyTypesLocally,
  makePropertyFavourite,
  removePropertyFromFavourite,
  getAllFavouritesPropertyForUser,
  addPropertyTypeForUser,
  setPropertyId,
};
